import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { NanobarService } from './nanobar.service';

@Component({
  selector: 'app-nanobar',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div
      class="nanobar"
      [class.visible]="nanobar.visible()"
      [class.no-transition]="nanobar.progress() === 0"
      [style.width.%]="nanobar.progress() * 100"
      role="progressbar"
      aria-label="Loading"
      [attr.aria-valuenow]="Math.round(nanobar.progress() * 100)"
      aria-valuemin="0"
      aria-valuemax="100"
    >
      <div class="peg"></div>
    </div>
  `,
  styles: [`
    /* Defaults: #CC0033, 3px. Override with --nanobar-color / --nanobar-height */
    .nanobar {
      position: fixed;
      top: 0;
      left: 0;
      height: var(--nanobar-height, 3px);
      width: 0;
      background: var(--nanobar-color, #CC0033);
      z-index: 10000;
      pointer-events: none;
      opacity: 0;
      transition: width 250ms ease-out, opacity 300ms linear;
    }

    .nanobar.visible {
      opacity: 1;
    }

    .nanobar.no-transition {
      transition: none;
    }

    .peg {
      position: absolute;
      right: 0;
      top: 0;
      width: 100px;
      height: 100%;
      box-shadow:
        0 0 10px var(--nanobar-color, #CC0033),
        0 0 5px var(--nanobar-color, #CC0033);
      opacity: 1;
      transform: rotate(3deg) translate(0, -4px);
    }
  `],
})
export class NanobarComponent {
  protected readonly nanobar = inject(NanobarService);
  protected readonly Math = Math;
}
